import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CompanyCaseMode } from "../_types/company-case-mode";

@Injectable({
    providedIn: 'root',
})
export class CompanyCaseModeService extends Service<CompanyCaseMode> {
    public override type = 'companyCaseModes';
    public override url = 'attendance/companyCaseModes';
}
